import { get, post, put } from './utils';

export async function approvedApi({ id, data }) {
  return post(`/return-orders/${id}/approved`, data);
}

export async function passQCApi({ id, data }) {
  return put(`/return-orders/${id}/pass-qc`, data);
}

export async function failedQCApi({ id, data }) {
  return post(`/return-orders/${id}/failed-qc`, data);
}

export async function cancelApi({ id, data }) {
  return put(`/return-orders/${id}/cancel`, data);
}

export const commentReturnApi = ({ id, data }) =>
  post(`/return-orders/${id}/comment`, data);

export const historiesApi = ({ id }) => get(`/return-orders/${id}/histories`);

export const paymentRefundApi = ({ id, data }) =>
  post(`/return-orders/${id}/payment/refund`, data);

export const validationChecklistApi = (id) =>
  get(`/return-orders/${id}/validation-checklist`);

export const completeReturnApi = (id) => post(`/return-orders/${id}/complete`);

export async function markAsSuccessApi({ id, data }) {
  return post(`/return-orders/${id}/mark-as-success`, data);
}

export async function markAsReceivedApi({ id, data }) {
  return post(`/return-orders/${id}/mark-as-received`, data);
}
